var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class MissingSignerError extends Error {
  constructor() {
    super("Must provide signer");
    __publicField(this, "name", "MissingSignerError");
  }
}
class MissingProviderError extends Error {
  constructor() {
    super("Must provide provider");
    __publicField(this, "name", "MissingProviderError");
  }
}
class MissingSignerOrProviderError extends Error {
  constructor() {
    super("Must provide signer or provider");
    __publicField(this, "name", "MissingSignerOrProviderError");
  }
}
class UnsupportedNetworkError extends Error {
  constructor({ chainId }) {
    super("Unsupported network chain ID");
    __publicField(this, "name", "UnsupportedNetworkError");
    __publicField(this, "chainId");
    this.chainId = chainId;
  }
}
class CreatorAddressMissing extends Error {
  constructor() {
    super(`"soundCreatorAddress" was not specified and it's required for the requested action`);
    __publicField(this, "name", "CreatorAddressMissingError");
  }
}
class InvalidAddressError extends Error {
  constructor({ type, address, message }) {
    super(message || "Invalid address");
    __publicField(this, "name", "InvalidAddressError");
    __publicField(this, "type");
    __publicField(this, "address");
    this.type = type;
    this.address = address;
  }
}
class UnsupportedMinterError extends Error {
  constructor({ interfaceId }) {
    super("Minter not handled by sdk");
    __publicField(this, "name", "UnsupportedMinterError");
    __publicField(this, "interfaceId");
    this.interfaceId = interfaceId;
  }
}
class NotSoundEditionError extends Error {
  constructor({ contractAddress }) {
    super("Address must be a sound edition contract");
    __publicField(this, "name", "NotSoundEditionError");
    __publicField(this, "contractAddress");
    this.contractAddress = contractAddress;
  }
}
class SamNotFoundError extends Error {
  constructor({ contractAddress }) {
    super("SAM could not be found for edition");
    __publicField(this, "name", "SamNotFoundError");
    __publicField(this, "contractAddress");
    this.contractAddress = contractAddress;
  }
}
class SoundNotFoundError extends Error {
  constructor({
    contractAddress,
    editionId = null,
    graphqlErrors
  }) {
    super("Sound could not be found");
    __publicField(this, "name", "SoundNotFoundError");
    __publicField(this, "contractAddress");
    __publicField(this, "editionId");
    __publicField(this, "graphqlErrors");
    this.contractAddress = contractAddress;
    this.editionId = editionId;
    this.graphqlErrors = graphqlErrors;
  }
}
class SoundAPILoginError extends Error {
  constructor({
    publicAddress,
    graphqlErrors
  }) {
    super("Error while trying to login into Sound.xyz API");
    __publicField(this, "name", "SoundAPILoginError");
    __publicField(this, "publicAddress");
    __publicField(this, "graphqlErrors");
    this.publicAddress = publicAddress;
    this.graphqlErrors = graphqlErrors;
  }
}
class SoundAPIGraphQLError extends Error {
  constructor({ graphqlErrors }) {
    super("Sound.xyz API GraphQL Error");
    __publicField(this, "name", "SoundAPIGraphQLError");
    __publicField(this, "graphqlErrors");
    this.graphqlErrors = graphqlErrors;
  }
}
class UnexpectedApiResponse extends Error {
  constructor({
    message,
    error,
    graphqlErrors
  } = {}) {
    super(message || "Unexpected API Response");
    __publicField(this, "name", "UnexpectedApiResponseError");
    __publicField(this, "originalError");
    __publicField(this, "unexpectedOriginalError");
    __publicField(this, "graphqlErrors");
    if (error instanceof Error) {
      this.originalError = error;
    } else {
      this.unexpectedOriginalError = error;
    }
    if (graphqlErrors) {
      this.graphqlErrors = graphqlErrors;
    }
  }
}
class InvalidQuantityError extends Error {
  constructor({ quantity }) {
    super("Must provide valid quantity");
    __publicField(this, "name", "InvalidQuantityError");
    __publicField(this, "quantity");
    this.quantity = Number(quantity);
  }
}
class InvalidOffsetError extends Error {
  constructor({ offset }) {
    super("Must provide valid non-negative integer offset");
    __publicField(this, "name", "InvalidOffsetError");
    __publicField(this, "offset");
    this.offset = offset;
  }
}
class InvalidTokenIdError extends Error {
  constructor({ tokenId }) {
    super("Must provide valid token id");
    __publicField(this, "name", "InvalidTokenIdError");
    __publicField(this, "tokenId");
    this.tokenId = tokenId;
  }
}
class InvalidAttributonIdError extends Error {
  constructor({ attributonId }) {
    super("Must provide valid BigNumber-like attributon id");
    __publicField(this, "name", "InvalidAttributonIdError");
    __publicField(this, "attributonId");
    this.attributonId = attributonId;
  }
}
class NotEligibleMint extends Error {
  constructor({
    userAddress,
    eligibleMintQuantity,
    mintSchedule
  }) {
    super("Not eligible to mint");
    __publicField(this, "name", "NotEligibleMintError");
    __publicField(this, "userAddress");
    __publicField(this, "eligibleMintQuantity");
    __publicField(this, "mintSchedule");
    this.userAddress = userAddress;
    this.eligibleMintQuantity = eligibleMintQuantity;
    this.mintSchedule = mintSchedule;
  }
}
class MissingApiKey extends Error {
  constructor() {
    super('Missing "apiKey" while creating SoundAPI instance');
    __publicField(this, "name", "MissingApiKeyError");
  }
}
class MissingSoundAPI extends Error {
  constructor() {
    super('Missing required "soundAPI" while creating SoundClient instance');
    __publicField(this, "name", "MissingSoundAPIError");
  }
}
class MissingMerkleProvider extends Error {
  constructor() {
    super('Missing required "merkleProvider" while creating SoundClient instance');
    __publicField(this, "name", "MissingMerkleProviderError");
  }
}
class UnexpectedLanyardResponse extends Error {
  constructor({ response, zodError, cause }) {
    super(
      response ? `Unexpected lanyard API response, status code ${response.status}` : "Unexpected lanyard API response",
      {
        cause
      }
    );
    __publicField(this, "name", "UnexpectedLanyardResponseError");
    __publicField(this, "response");
    __publicField(this, "zodError");
    this.response = response;
    this.zodError = zodError || null;
  }
}
class InvalidEditionMaxMintableError extends Error {
  constructor({
    editionMaxMintableLower,
    editionMaxMintableUpper
  }) {
    super("editionMaxMintableLower cannot be greater than editionMaxMintableUpper");
    __publicField(this, "name", "InvalidEditionMaxMintableError");
    __publicField(this, "editionMaxMintableLower");
    __publicField(this, "editionMaxMintableUpper");
    this.editionMaxMintableLower = editionMaxMintableLower;
    this.editionMaxMintableUpper = editionMaxMintableUpper;
  }
}
class InvalidMaxMintableError extends Error {
  constructor({ maxMintableLower, maxMintableUpper }) {
    super("maxMintableLower cannot be greater than maxMintableUpper");
    __publicField(this, "name", "InvalidMaxMintableError");
    __publicField(this, "maxMintableLower");
    __publicField(this, "maxMintableUpper");
    this.maxMintableLower = maxMintableLower;
    this.maxMintableUpper = maxMintableUpper;
  }
}
class InvalidMaxMintablePerAccountError extends Error {
  constructor({ maxMintablePerAccount }) {
    super("maxMintablePerAccount must be greater than 0");
    __publicField(this, "name", "InvalidMaxMintablePerAccountError");
    __publicField(this, "maxMintablePerAccount");
    this.maxMintablePerAccount = maxMintablePerAccount;
  }
}
class InvalidMerkleRootError extends Error {
  constructor({ merkleRoot }) {
    super("merkleRoot must be a valid bytes32 hash");
    __publicField(this, "name", "InvalidMerkleRootError");
    __publicField(this, "merkleRoot");
    this.merkleRoot = merkleRoot;
  }
}
class InvalidTimeValuesError extends Error {
  constructor({ startTime, cutoffTime, endTime }) {
    super("startTime must be earlier than cutoffTime and cutoffTime must be earlier than endTime");
    __publicField(this, "name", "InvalidTimeValuesError");
    __publicField(this, "startTime");
    __publicField(this, "cutoffTime");
    __publicField(this, "endTime");
    this.startTime = startTime;
    this.cutoffTime = cutoffTime;
    this.endTime = endTime;
  }
}
class InvalidTxHashError extends Error {
  constructor({ txHash }) {
    super("Must be a valid bytes32 transaction hash");
    __publicField(this, "name", "InvalidTxHashError");
    __publicField(this, "txHash");
    this.txHash = txHash;
  }
}
class InvalidMerkleProofError extends Error {
  constructor({ proof }) {
    super("Must be a valid merkle proof");
    __publicField(this, "name", "InvalidMerkleProofError");
    __publicField(this, "proof");
    this.proof = proof;
  }
}
class InvalidHexError extends Error {
  constructor({ value }) {
    super("Must be a valid hex value that starts with 0x");
    __publicField(this, "name", "InvalidHexError");
    __publicField(this, "value");
    this.value = value;
  }
}

export { CreatorAddressMissing, InvalidAddressError, InvalidAttributonIdError, InvalidEditionMaxMintableError, InvalidHexError, InvalidMaxMintableError, InvalidMaxMintablePerAccountError, InvalidMerkleProofError, InvalidMerkleRootError, InvalidOffsetError, InvalidQuantityError, InvalidTimeValuesError, InvalidTokenIdError, InvalidTxHashError, MissingApiKey, MissingMerkleProvider, MissingProviderError, MissingSignerError, MissingSignerOrProviderError, MissingSoundAPI, NotEligibleMint, NotSoundEditionError, SamNotFoundError, SoundAPIGraphQLError, SoundAPILoginError, SoundNotFoundError, UnexpectedApiResponse, UnexpectedLanyardResponse, UnsupportedMinterError, UnsupportedNetworkError };
